import {
    GET_SKETCH_ORDER_TIERS_FAILURE,
    GET_SKETCH_ORDER_TIERS_REQUEST,
    GET_SKETCH_ORDER_TIERS_SUCCESS
} from "../actions/actionTypes";

const initState = {
    isFetching: false,
    sketchOrderTiers: [],
};

const sketchOrderTierReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_SKETCH_ORDER_TIERS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SKETCH_ORDER_TIERS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                sketchOrderTiers: action.response.resourceList,
            });
        case GET_SKETCH_ORDER_TIERS_FAILURE:
            return initState;
        default:
            return state;
    }
};

export default sketchOrderTierReducer;
